export const HERO_CONSTANTS = {
  title: "Our Expertise | Your Success",
  desc: "Full-Service MSP & CSP Specializing in Cloud, Security, IoT & Datacenter Technologies.",
  btnText: "Talk To Our Experts Today",
};
